import { CheckAllState } from "types/enum";

import { type KeyOfOrString } from "utilities/type/PropsOfType";

export function getCheckAllState(rows: any[], propertyName: KeyOfOrString) {
    if (rows.some((row) => row[propertyName])) {
        if (rows.every((row) => row[propertyName] || row[propertyName] === null)) {
            return CheckAllState.AllChecked;
        }
        return CheckAllState.Indeterminate;
    }
    return CheckAllState.None;
}
